var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: { size: "sm", "hide-footer": "", title: "" }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h3", [_vm._v("編輯")])
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c("label", { staticClass: "col-sm-2", attrs: { for: "" } }, [
              _vm._v("名稱")
            ]),
            _c("div", { staticClass: "col-sm-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.button.Text,
                    expression: "button.Text"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "名稱" },
                domProps: { value: _vm.button.Text },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.button, "Text", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _c(
            "b-button",
            {
              staticClass: "mt-2",
              attrs: { variant: "btn btn-primary", block: "" },
              on: {
                click: function($event) {
                  return _vm.toggleModal()
                }
              }
            },
            [_vm._v("儲存")]
          ),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "btn btn-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("關閉")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }